import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the recruiters module.
 * @return {*}
 */
export default function useTranslationRecruiters() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/recruiters.json'),
    'fr': import('./locales/fr/recruiters.json')
  }), []);

  return useModuleTranslation('recruiters', imports);
}
